export function Decoration() {
  return null
}
export const BG: string | undefined = undefined
